import React from "react";

function DockRightIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 341.8 236.52"
            width={20}
            fill="currentColor"
        >
            <g data-name="Layer 2">
                <g data-name="Layer 1">
                    <g data-name="Groupe 135">
                        <path
                            d="M289.32 24a28.64 28.64 0 0128.55 28.64v131.23a28.63 28.63 0 01-28.55 28.63H52.48a28.63 28.63 0 01-28.55-28.63V52.62A28.64 28.64 0 0152.48 24h236.84m0-24H52.48A52.56 52.56 0 000 52.64v131.25a52.56 52.56 0 0052.48 52.63h236.84a52.56 52.56 0 0052.48-52.63V52.64A52.56 52.56 0 00289.32 0z"
                            data-name="Tracé 72"
                        ></path>
                    </g>
                    <rect
                        width="156.25"
                        height="208.11"
                        x="166.62"
                        y="14.19"
                        data-name="Rectangle 34"
                        rx="39.06"
                    ></rect>
                </g>
            </g>
        </svg>
    );
}

export default DockRightIcon;
